import { Pipe, PipeTransform } from '@angular/core';
import momentLocale from 'moment/min/moment-with-locales';

@Pipe({
    name: 'dateFormat',
    standalone: true,
})
export class DateFormatPipe implements PipeTransform {

    transform(value: string | number | Date, format?: string, language = ''): string {
        const languageLowerCase = language.toLocaleLowerCase();
        return momentLocale(value, '', languageLowerCase).format(format);
    }

}
